var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-customer-badge",style:(_vm.badgeStyle)},[_c('dd-icon',{attrs:{"icon":"mdi mdi-email color-grey-less-transparent","size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }